import {useSelector} from 'react-redux';

import {userSelector} from './authSlice';

const useIsFreeTariff = (): boolean => {
    const user = useSelector(userSelector);

    return user?.tariff.price === 0;
};

export default useIsFreeTariff;
